// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BoxPlotTwoToneSvg from "@fishx/icons-svg/es/asn/BoxPlotTwoTone";
import FishxIcon from '../components/FishxIcon';

var BoxPlotTwoTone = function BoxPlotTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotTwoToneSvg
  }));
};

BoxPlotTwoTone.displayName = 'BoxPlotTwoTone';
export default React.forwardRef(BoxPlotTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BoxPlotTwoTone.js
// module id = 2118
// module chunks = 0